import UIComponent from "../../common/UIComponent";
import "./index.css";

/**
 *  @description 当前播放时间 - UI 控件
 */
export default class H5CurrentTime extends UIComponent {

  constructor(elementId, interfaces) {
    super()
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();

    this.interfaces.on(VhallPlayer.TIMEUPDATE, () => {
      this.h5currentTime.innerText = this._secondToDate(this.interfaces.getCurrentTime())
    });

  }

  init() {
    this.h5currentTime = document.createElement("span");
    this.h5currentTime.setAttribute("class", "vhallPlayerh5-currenttime");
    this.h5currentTime.innerText = "00:00:00";
    this.insertElement(this.elementId, this.h5currentTime);
    // this.appendChild(this.elementId, this.h5currentTime);
  }


  // _secondToDate(result) {
  //   var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  //   var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  //   var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  //   return result = (Number(m) + Number(h * 60)) + ":" + s;
  // }

  _secondToDate(result) {
    var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
    var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
    return result = h + ":" + m + ":" + s;
  }

}